<div class="m-5" *ngIf="!event && !error">
    <app-spinner></app-spinner>
</div>

<div *ngIf="error">
    <app-errormessage
        [serverErrorMessage]="error.message"
        [errorMessageTranslationKey]="error.localizationKey">
    </app-errormessage>
</div>

<ng-container *ngIf="event && !error">
    <div class="container event-banner" [style.background-image]="'url(' + getBannerImage() + ')'">
        <ng-container *ngIf="event">
            <div class="row">
                <div class="col-md-12">
                    <h2 class="section-landing-heading">{{ event.eventName }}</h2>
                    <h4 class="event-date">
                        <ng-template [ngIf]="isMultiDayEvent(event)">
                            {{ event.startDate | date: 'dd.MM' :'undefined': this.labelsService.language}}
                            -
                        </ng-template>
                        {{ event.endDate   | date: 'mediumDate' :'undefined': this.labelsService.language}}
                        <br>
                        {{ event.startDate | date: 'shortTime' :'undefined': this.labelsService.language}} -
                        {{ event.endDate   | date: 'shortTime' :'undefined': this.labelsService.language}}

                        <ng-template [ngIf]="isOnlineEvent(event)">
                            ({{ event.endDate | date: 'z' :'undefined': this.labelsService.language}})
                        </ng-template>
                    </h4>
                    <h4 class="event-location">{{ event.building ? event.building.name : '' }}</h4>
                    <h4 class="event-location">{{ event.building ? event.building.addressLine1 : '' }}</h4>
                    <h4 class="event-location">{{ event.building ? event.building.postalCode : '' }} {{ event.building ? event.building.city : '' }}</h4>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="event" class="container">
        <div class="row register-container" id="register-now">
            <button
                *ngIf="!isSessionCartAllowed && canUserRegister()"
                [routerLink]="['registration']"
                [queryParams]="{id: event.readableEventId}"
                class="button button--secondary">
                <span class="icon-padding" [appTranslate]="'RegisterNow'">Register Now</span>
            </button>
            <button
                *ngIf="isSessionCartAllowed && canUserRegister()"
                (click)="registerForSessions()"
                class="btn btn-primary btn-lg">
                <span class="icon-padding" [appTranslate]="'RegisterNow'">Register Now</span>
            </button>
        </div>
    </div>

    <div *ngIf="!canUserRegister()" class="alert alert-warning container event-data-container-warning text-center" role="alert">
        <span *ngIf="event.websiteMessage">{{event.websiteMessage}}</span>
        <span *ngIf="!event.websiteMessage" [appTranslate]="'RegistrationsClosed'">Registrations Closed</span>
    </div>

    <ng-container *ngIf="event">
        <section class="section section--bg-light c-text">
            <div class="section__container">
                <div class="c-text__wrapper text-left">
                    <div class="c-text__content" [innerHTML]="event.description | safe:'html'">
                    </div>
                </div>
            </div>
        </section>
    </ng-container>

    <div [hidden]="!event || ((!sessions || sessions.length===0) && !showSessionTracks && !showSpeakers && !showPasses)" class="container event-data-container mt-4">
        <ul class="nav nav-tabs">
            <li *ngIf="sessions && sessions.length > 0" class="nav-item">
                <a [routerLink]="['/event', EventDetailSections.Sessions]" [queryParams]="{ id: readableEventId}"
                    routerLinkActive="active" class="button button--text" id="btn-show-sessions-list">
                    <span class="button__text" [appTranslate]="'Sessions'">Sessions</span>
                </a>
            </li>
            <li *ngIf="showSessionTracks" class="nav-item">
                <a [routerLink]="['/event', EventDetailSections.SessionTracks]" [queryParams]="{ id: readableEventId}"
                    routerLinkActive="active" class="button button--text" id="btn-show-sessions-tracks-list">
                    <span class="button__text" [appTranslate]="'SessionTracks'">SessionTracks</span>
                </a>
            </li>
            <li *ngIf="showSpeakers" class="nav-item">
                <a [routerLink]="['/event', EventDetailSections.Speakers]" [queryParams]="{id: readableEventId}"
                   routerLinkActive="active" class="button button--text" id="btn-show-speakers-list">
                    <span class="button__text" [appTranslate]="'Speakers'">Speakers</span>
                </a>
            </li>
            <li *ngIf="showPasses" class="nav-item">
                <a [routerLink]="['/event', EventDetailSections.PassInformation]" [queryParams]="{id: readableEventId }"
                    routerLinkActive="active" class="button buttonbutton button--text" id="btn-show-pass-list">
                    <span class="button__text" [appTranslate]="'PassInformation'">PassInformation</span>
                </a>
            </li>
        </ul>
        <div class='mt-4'>
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-container>

<aside>
    <app-session-cart [readableEventId]="readableEventId"></app-session-cart>
</aside>
